import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder,FormArray, FormGroupDirective} from '@angular/forms'
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Subject } from "rxjs";
import { _ } from 'underscore';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-item-master',
  templateUrl: './item-master.component.html',
  styleUrls: ['./item-master.component.scss']
})
export class ItemMasterComponent implements OnInit
{
  items:any=[];
  editItemId:any;
  editItemStatus:boolean = false
  itemMaster: FormGroup;
  unitVariableForm: FormGroup;
  finalGramage:number=0;
  selected:any = 1;
  message:string='';
  user_id:any;
  business_id:any;
  parent_id:any;
  loggedUserInfo:any=[]
  units:any=[]
  unit_variables_arr:any=[]
  showUnitVariablePopupStatus:boolean = false
  unitVariableEditId:any=''
  editUnitVariableStatus:boolean =false;
  unitVariableIterateSubscriber:any;
  unitVariableIterationObserver:any = new Subject<any>();
  editUnitVariables:any=[]
  csvData:any=[]
  mySelections:any=[]
  csvDataForm:FormGroup;
  showModel:boolean = false;
  uploadSubscribeVariable:any;
  iterationObserver:any = new Subject<any>();
  saveItemSubscribeVariable:any;
  saveItemIterationObserver:any = new Subject<any>();
  @ViewChild('fileInput',{static: false}) fileInput:any;
  constructor(private observables:ObservablesService, private modalService: NgbModal,private formBuilder: FormBuilder,private api:ApiService) { }

  ngOnInit() {
    this.getUnits()

    this.api.getLoggedUserInfo().then((res:any)=>{
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        if(this.loggedUserInfo.level == 1){
          this.business_id = this.loggedUserInfo.business_id
          this.user_id = this.loggedUserInfo.id
        }else if(this.loggedUserInfo.level > 1){
          this.user_id = this.loggedUserInfo.id
          this.parent_id = this.loggedUserInfo.parent_id
          this.business_id = this.loggedUserInfo.business_id
        }else{
          this.api.logOut()
        }

        this.getUnitVariables()

        this.getItem();

      }
    })
    // gst:['', Validators.required],
    this.itemMaster = this.formBuilder.group({
      name: ['', Validators.required],
      item_code: [null],
      gst:['', Validators.compose([Validators.required,Validators.pattern(/^(100|[0-9]{1,2})?$/)])],
      rate:[null, Validators.compose([Validators.required, Validators.pattern(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/)])],
      hsn_code:[null],
      cess:[0, Validators.compose([Validators.required,Validators.pattern(/^(100|[0-9]{1,2})?$/)])],
      discount:[0, Validators.compose([Validators.required,Validators.pattern(/^(100|[0-9]{1,2})?$/)])],
      unit_id:[null, Validators.required],
      unit_variables:[null, Validators.required]
    });

  }

  changed() {
    if (this.itemMaster.get('unit_variables').value.length < 4) {
      this.mySelections = this.itemMaster.get('unit_variables').value;
    } else {
      this.itemMaster.get('unit_variables').setValue(this.mySelections);
    }
  }

  getUnits(){
    this.api.send('findDb',{
      table:"units",
    }).then((res:any)=>{
      this.units = res.data;
      if(this.units.length > 0){
        this.itemMaster.patchValue({unit_id:this.units[0].id})
      }
    })
  }
  getUnitVariables(){
    this.api.send('findDb',{
      table:"unit_variables",
      conditions:[{business_id:this.loggedUserInfo.business_id}]
    }).then((res:any)=>{
      this.unit_variables_arr = res.data;
    })
  }

  getItem(){
  this.items= []
   this.api.send("findDb",{
     table:"items as I",
     fields:["U.name as unit","U.id as unit_id","UV.name as unit_variable","IU.unit_variable_id","I.*"],
     joins:[{
       type:'left',
       table:'item_unit_variables as IU',
       conditions:["IU.item_id = I.id"]
     },{
       type:'left',
       table:'unit_variables as UV',
       conditions:["UV.id = IU.unit_variable_id"]
     },{
       type:'left',
       table:'units as U',
       conditions:["U.id = I.unit_id"]
     }],
     conditions:[{"I.business_id":this.business_id}]
   }).then((result:any)=>{
     let group = _.groupBy(result.data,'id')
     let value = _.values(group);

     value.filter((item)=>{
      if(item.length > 1){
        let unit_variables=[]

        for(let i=0;i<item.length;i++){
          unit_variables.push({unit_variable:item[i].unit_variable,unit_variable_id:item[i].unit_variable_id})

          if(i == item.length -1){

            this.items.push({
              business_id: item[0].business_id,
              cess: item[0].cess,
              discount: item[0].discount,
              gst: item[0].gst,
              id: item[0].id,
              name: item[0].name,
              item_code: item[0].item_code,
              rate: item[0].rate,
              hsn_code: item[0].hsn_code,
              unit:item[0].unit,
              unit_id:item[0].unit_id,
              unit_variables: unit_variables,
              unit_variable_name:Array.prototype.map.call(unit_variables, s => s.unit_variable).toString()
              // unit_id:item[0].unit_id
            })
          }
        }
      }else{

        this.items.push({
          business_id: item[0].business_id,
          cess: item[0].cess,
          discount: item[0].discount,
          gst: item[0].gst,
          id: item[0].id,
          name: item[0].name,
          item_code: item[0].item_code,
          rate: item[0].rate,
          hsn_code: item[0].hsn_code,
          unit:item[0].unit,
          unit_id:item[0].unit_id,
          unit_variables: [{unit_variable:item[0].unit_variable,unit_variable_id:item[0].unit_variable_id}],
          unit_variable_name:item[0].unit_variable
        })
      }
     })
     //
     // console.log("group==",group)
     // console.log("value==",value)
     // console.log("item==",this.items)
   })
  }

  cancel(){
    this.editItemStatus = false;
    this.itemMaster.reset()
  }

  onChange(event){
    // console.log("event=",event)
    // if(event.value == 1){
    //   this.itemMaster.get('gramage').setValidators([Validators.required]);
    // }else{
    //   this.itemMaster.get('gramage').clearValidators();
    //   this.itemMaster.patchValue({gramage:''})
    //   this.finalGramage=0;
    // }
    //
    // this.itemMaster.updateValueAndValidity();
  }

  calculateGramage(){
    // let x = value;
    this.finalGramage = this.itemMaster.get('gramage').value/800;
    // this.itemMaster.patchValue({gramage:})
  }

  submitData(value,formDirective:FormGroupDirective,action){
    // console.log("value==",value);
    if(action == 'add'){
      this.api.send("insertDb",{
        table:"items",
        data:{
          name:value.name,
          item_code: value.item_code,
          business_id:this.loggedUserInfo.business_id,
          rate:value.rate,
          hsn_code: value.hsn_code,
          gst:value.gst,
          cess:value.cess,
          discount:value.discount,
          unit_id:value.unit_id
        }
      }).then((result:any)=>{
        if(result.data.affectedRows){
          if(value.unit_variables){
            this.addUnitVariables(value.unit_variables,result.data.insertId).then((res:any)=>{
              formDirective.resetForm();
              this.itemMaster.reset();
              this.itemMaster.patchValue({unit_id:value.unit_id,cess:0,discount:0})
              this.selected = value.unit_id;
              this.message = "Added !";
              // this.finalGramage = 0;
              setTimeout(()=>{
                this.message = ''
              },3000)
              this.getItem();
            })
          }

        }else{
          this.message = "Not added !";
          setTimeout(()=>{
            this.message = ''
          },3000)
        }

      })
    }else{

      this.api.send("updateDb",{
        table:"items",
        data:{
          name:value.name,
          item_code: value.item_code,
          business_id:this.loggedUserInfo.business_id,
          rate:value.rate,
          hsn_code: value.hsn_code,
          gst:value.gst,
          cess:value.cess,
          discount:value.discount,
          unit_id:value.unit_id

        },
        conditions:[{
          id:this.editItemId
        }]
      }).then((result:any)=>{
        if(result.data.affectedRows){
          if(value.unit_variables){
            if(this.editUnitVariables.length > 0){
              let intersectionArr = _.intersection(value.unit_variables,this.editUnitVariables);
              // console.log("intersection=",_.intersection(value.units,this.editunits));
              let differenceArr1 = _.difference(value.unit_variables,intersectionArr)
              // console.log("differenceArr1==",differenceArr1)
              let differenceArr2 = _.difference(this.editUnitVariables,intersectionArr)
              // console.log("differenceArr2==",differenceArr2)
              if(differenceArr1.length > 0 && differenceArr2.length > 0){
                //add from diff1 and remove from diff2
                this.addUnitVariables(differenceArr1,this.editItemId).then((res:any)=>{
                  this.removeUnitVariables(differenceArr2,this.editItemId).then((res1:any)=>{
                    this.resetAll(formDirective,value)
                  })
                })
              }else if(differenceArr1.length == 0 && differenceArr2.length == 0){
                //units not updated same as before
                this.resetAll(formDirective,value)
              }else if(differenceArr1.length > 0 && differenceArr2.length == 0){
                //add from diff1
                this.addUnitVariables(differenceArr1,this.editItemId).then((res:any)=>{
                  this.resetAll(formDirective,value)
                })
              }else if(differenceArr1.length == 0 && differenceArr2.length > 0){
                //remove from diff2
                this.removeUnitVariables(differenceArr2,this.editItemId).then((res1:any)=>{
                  this.resetAll(formDirective,value)
                })
              }
            }else{
              //update all
              this.addUnitVariables(value.unit_variables,this.editItemId).then((res:any)=>{
                this.resetAll(formDirective,value)
              })
            }
          }else{
            if(this.editUnitVariables.length > 0){
              //remove all units
              this.removeUnitVariables(this.editUnitVariables,this.editItemId).then((res1:any)=>{
                this.resetAll(formDirective,value)
              })
            }
          }

        }else{
          this.message = "Not updated !";
          setTimeout(()=>{
            this.message = ''
          },3000)
        }
      })
    }
  }

  resetAll(formDirective,value){
    formDirective.resetForm();
    this.itemMaster.reset();
    this.itemMaster.patchValue({unit_id:value.unit_id,cess:0,discount:0})
    this.selected = value.unit_id;
    this.message = "updated !";
    // this.finalGramage = 0;
    this.editItemId = "";
    this.editItemStatus = false;
    setTimeout(()=>{
      this.message = ''
    },3000)
    this.getItem();
  }

  addUnitVariables(unit_variables,item_id){
    return new Promise((resolve)=>{
      let k= 0;
      this.unitVariableIterateSubscriber = this.unitVariableIterationObserver.subscribe((k)=>{
        if(k >= unit_variables.length){
          this.unitVariableIterateSubscriber.unsubscribe()
          resolve(true)
        }else{
          this.api.send("insertDb",{
            table:'item_unit_variables',
            data:{
              business_id:this.loggedUserInfo.business_id,
              item_id:item_id,
              unit_variable_id:unit_variables[k]
            }
          }).then((res:any)=>{

            this.unitVariableIterationObserver.next(k+1);
          })
        }
      })
      this.unitVariableIterationObserver.next(k)
    })
  }

  removeUnitVariables(unit_variables,item_id){
    return new Promise((resolve)=>{
      let k= 0;
      this.unitVariableIterateSubscriber = this.unitVariableIterationObserver.subscribe((k)=>{
        if(k >= unit_variables.length){
          this.unitVariableIterateSubscriber.unsubscribe()
          resolve(true)
        }else{
          this.api.send("deleteDb",{
            table:'item_unit_variables',
            conditions:[{item_id:item_id,unit_variable_id:unit_variables[k]}]
          }).then((res:any)=>{

            this.unitVariableIterationObserver.next(k+1);
          })
        }
      })
      this.unitVariableIterationObserver.next(k)
    })
  }

  deleteItem(id){
    if(confirm("Are you sure to delete item?")){

      this.api.send("deleteDb",{
        table:"items",
        conditions:[{id:id}]
      }).then((result:any)=>{

        if(result.data.affectedRows){

          this.getItem();
        }
      })
    }
  }

  editItem(item){
    this.editItemId = item.id;
    this.editItemStatus = true;
    // console.log("edit item==",item)
    this.selected = item.unit_id;
    this.itemMaster.patchValue({
      name:item.name,
      item_code: item.item_code,
      gst:item.gst,
      rate:item.rate,
      hsn_code:item.hsn_code,
      cess:item.cess,
      discount:item.discount,
      unit_id:item.unit_id,
      unit_variables:[null]
    });
    this.editUnitVariables=[]
    this.api.send("findDb",{
      table:"item_unit_variables",
      conditions:[{item_id:item.id}]
    }).then((res:any)=>{
      if(res.data.length > 0){
        for(let i=0;i<res.data.length;i++){
          this.editUnitVariables.push(res.data[i].unit_variable_id)
          if(i==res.data.length -1){

            this.itemMaster.patchValue({unit_variables:this.editUnitVariables})
            // console.log("units=",units)
          }
        }

      }
    })

    // this.calculateGramage()

  }

  getUnitVariable(unit_variable_id){

    for(let i=0;i<this.unit_variables_arr.length;i++){
      if(this.unit_variables_arr[i].id == unit_variable_id){
        return this.unit_variables_arr[i].name
      }
    }
  }

  openModal(){
    this.unitVariableForm= this.formBuilder.group({
      name:[null,Validators.required]
    });
    this.showUnitVariablePopupStatus = true;
  }

  closeUnitVariableModel(){

    this.showUnitVariablePopupStatus = false;
  }


  addUnitVariable(value){

    this.api.send("insertDb",{
      table:"unit_variables",
      data:{
        business_id:this.business_id,
        name:value.name
      }
    }).then((res:any)=>{
      if(res.data.affectedRows){
        this.unitVariableForm.reset()
        this.getUnitVariables()
        this.observables.showToastMessage({type:0,message: 'Unit Variable saved..'});
      }else{
       this.observables.showToastMessage({type:1,message: 'Unit Variable not saved..'});
      }
    })
  }

  editUnitVariable(unitVariable){
    this.unitVariableEditId = unitVariable.id;
    this.unitVariableForm.patchValue({name:unitVariable.name});
    this.editUnitVariableStatus = true;
  }
  cancelEdit(){
    this.unitVariableEditId = '';
    this.unitVariableForm.reset();
    this.editUnitVariableStatus = false;
  }

  updateUnitVariable(value){
    if(confirm("Are you sure to Update Unit Variable?")){
      this.api.send("findDb",{
        table:'unit_variables',
        conditions:[{name:value.name,business_id:this.loggedUserInfo.business_id}]
      }).then((res:any)=>{
        if(res.data.length > 0){
          this.observables.showToastMessage({type:1,message:"Unit Variable Already Exists."})
        }else{
          this.api.send("updateDb",{
            table:'unit_variables',
            data:{name:value.name},
            conditions:[{id:this.unitVariableEditId,business_id:this.loggedUserInfo.business_id}]
          }).then((res1:any)=>{
            if(res1.data.affectedRows){
              this.getUnitVariables()
              this.cancelEdit()
              this.observables.showToastMessage({type:0,message:"Unit Variable Updated.."})
            }else{

              this.observables.showToastMessage({type:1,message:"Can\'t update unit variable, Try again."})
            }
          })
        }
      })
    }
  }

  deleteUnitVariable(id){
    if(confirm("Are you sure to delete Unit Variable?")){

      this.api.send("deleteDb",{
        table:'unit_variables',
        conditions:[{id:id,business_id:this.loggedUserInfo.business_id}]
      }).then((res1:any)=>{
        if(res1.data.affectedRows){
          this.getUnitVariables()
          this.cancelEdit()
          this.observables.showToastMessage({type:0,message:"Unit Variable Deleted.."})
        }else{

          this.observables.showToastMessage({type:1,message:"Can\'t delete unit variable, Try again."})
        }
      })
    }
  }

  resetFile(){
    this.fileInput.nativeElement.value = null;
  }

  closeModel(){
    this.fileInput = null
    this.showModel = false;
  }

  deleteRow(index) {

      const control = <FormArray>this.csvDataForm.controls['csvRecord'];
      control.removeAt(index);
      this.csvData.splice(index, 1);
      if(this.csvData.length == 0){
        this.closeModel()
      }
  }

  selectedFile(ev){

    if(ev.target.files.length > 0 && ev.target.files[0].type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
      // console.log(ev.target.files)
      let workBook = null;
       let jsonData = null;
       const reader = new FileReader();
       const file = ev.target.files[0];
       reader.onload = (event) => {
         const data = reader.result;
         workBook = XLSX.read(data, { type: 'binary' });
         jsonData = workBook.SheetNames.reduce((initial, name) => {
           const sheet = workBook.Sheets[name];
           initial[name] = XLSX.utils.sheet_to_json(sheet);
           return initial;
         }, {});
         // console.log(jsonData)
         if(_.has(jsonData,'data')){

           this.csvData = jsonData.data;
           if(this.csvData.length > 0){

             if(_.has(this.csvData[0],'item_name') && _.has(this.csvData[0],'rate') && _.has(this.csvData[0],'unit')){

               this.showModel = true;
               this.csvDataForm = this.formBuilder.group({

                 'csvRecord':this.formBuilder.array([this.initItemRows()])
               });


               let k = 0;
               this.uploadSubscribeVariable = this.iterationObserver.subscribe((k)=>{
                 if(k>=this.csvData.length){
                   this.uploadSubscribeVariable.unsubscribe();

                 }else{

                   this.patchCsvArrayData(this.csvData[k],k).then((res)=>{

                     this.iterationObserver.next(k+1);
                   })
                 }
               })

               this.iterationObserver.next(k);
             }else{
               this.observables.showToastMessage({type:1,message: 'Wrong template selected, Please refer sample file'});
             }
           }else{
             this.observables.showToastMessage({type:1,message: 'Wrong template selected, Please refer sample file'});
           }
         }else{
           this.observables.showToastMessage({type:1,message: 'Invalid sheet name , Please refer sample file'});
         }

       }
       reader.readAsBinaryString(file);
    }else{
      this.observables.showToastMessage({type:1,message: 'Please select Execl file'});
    }
  }

  patchCsvArrayData(csvData,index){
    return new Promise((resolve)=>{
      const control = <FormArray>this.csvDataForm.controls['csvRecord'];
      control.at(index).patchValue({
        'name':csvData.item_name,
        'item_code':csvData.item_code,
        'rate':csvData.rate,
        'hsn_code':csvData.hsn_code,
        'gst':csvData.gst,
        'cess':csvData.cess,
        'discount':csvData.discount
      })

      for(let i=0;i<this.units.length;i++){
        if(this.units[i].name.toLowerCase() == csvData.unit.toLowerCase()){
          control.at(index).patchValue({'unit':this.units[i].id})
          break;
        }

        if(i == this.units.length - 1){
          control.at(index).patchValue({'unit':''})
        }

      }

      if(_.has(csvData,'unit_variable_1')){
        this.checkVariableExists(csvData,csvData.unit_variable_1,'unit_variable_1',control,index)
      }else{
        control.at(index).patchValue({'unit_variable_1':''})
      }

      if(_.has(csvData,'unit_variable_2')){
        this.checkVariableExists(csvData,csvData.unit_variable_2,'unit_variable_2',control,index)
      }else{
        control.at(index).patchValue({'unit_variable_2':''})
      }

      if(_.has(csvData,'unit_variable_3')){
        this.checkVariableExists(csvData,csvData.unit_variable_3,'unit_variable_3',control,index)
      }else{
        control.at(index).patchValue({'unit_variable_3':''})
      }
      if(index != this.csvData.length - 1){
        this.add_row();
      }

      resolve(true)
    })
  }

  checkVariableExists(csvData, unit_variable, variable, control, index){
    for(let i=0;i<this.unit_variables_arr.length;i++){

      if(this.unit_variables_arr[i].name.toLowerCase() == unit_variable.toLowerCase()){
        control.at(index).patchValue({[variable]:this.unit_variables_arr[i].id})
        break;
      }

      if(i == this.unit_variables_arr.length - 1){
        control.at(index).patchValue({[variable]:''})
      }
    }
  }

  add_row(){

    const control = <FormArray>this.csvDataForm.controls['csvRecord'];
    control.push(this.initItemRows());
  }

  initItemRows() {
    return this.formBuilder.group({
      'name': [{value:''},Validators.compose([Validators.required])],
      'item_code':[{value:''}],
      'unit':[{value:''},Validators.compose([Validators.required])],
      'unit_variable_1':[{value:''},Validators.compose([Validators.required])],
      'unit_variable_2':[{value:''}],
      'unit_variable_3':[{value:''}],
      'rate':[{value:''},Validators.compose([Validators.required])],
      'hsn_code':[{value:''}],
      'gst':[{value:''},Validators.compose([Validators.required])],
      'cess':[{value:''},Validators.compose([Validators.required])],
      'discount':[{value:''},Validators.compose([Validators.required])],
      'status': [{value:''}],
      'message': [{value:''}]
    });
  }

  saveAll(){
    let value = this.csvDataForm.getRawValue().csvRecord;
    let k = 0;
    this.saveItemSubscribeVariable = this.saveItemIterationObserver.subscribe((k)=>{
      if(k>=value.length){
        this.saveItemSubscribeVariable.unsubscribe();
        this.observables.showToastMessage({type:0,message: 'Items saved..'});
        this.getItem();
        this.closeModel()
      }else{
        this.saveItem(value[k]).then((res)=>{

          this.saveItemIterationObserver.next(k+1);
        })
      }
    })

    this.saveItemIterationObserver.next(k);

  }

  saveItem(value){
    return new Promise((resolve)=>{
      this.api.send("insertDb",{
        table:"items",
        data:{
            name:value.name,
            item_code:(value.item_code===undefined)?null:value.item_code,
            business_id:this.loggedUserInfo.business_id,
            rate:value.rate,
            hsn_code:value.hsn_code,
            gst:value.gst,
            cess:value.cess,
            discount:value.discount,
            unit_id:value.unit
          }
        }).then((result:any)=>{
          if(result.data.affectedRows){

            this.addUnitVariables(this.getVariableArray(value),result.data.insertId).then((res:any)=>{
              resolve(true)
            })
          }
        })
    })
  }

  getVariableArray(value){
    // console.log(value)
    let variableArr = []
    if(value.unit_variable_1 != ''){
      variableArr.push(value.unit_variable_1)
    }

    if(value.unit_variable_2 != ''){
      variableArr.push(value.unit_variable_2)
    }

    if(value.unit_variable_3 != ''){
      variableArr.push(value.unit_variable_3)
    }

    return variableArr;
  }
}
